import { AddPatientNew } from 'domain/usecases/patient/add-patient-new'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteAddPatientNew implements AddPatientNew {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  add(params: AddPatientNew.Params): Promise<AddPatientNew.Model> {
    return this.patientRepository.addPatientNew(params)
  }
}
